import { appUserAgent } from "@/lib/links/in-app";

/* iOS stops opening app.ppl-ai.com links in the app once a person picks Safari for the site;
   Apple's banner and our bar are the way back. */

const APP_STORE_ID = "6823889147";

export type Phone = "ios" | "android";

/** The phone this browser runs on; null on a computer and inside the app's own web view. */
export function phoneOf(userAgent: string, touchPoints = 0): Phone | null {
  if (appUserAgent(userAgent)) return null;
  if (/Android/.test(userAgent) && /Mobile/.test(userAgent)) return "android";
  if (/iPhone|iPod/.test(userAgent)) return "ios";
  // An iPad asks for the desktop site and says Macintosh; only its touch screen gives it away.
  if (/iPad/.test(userAgent) || (/Macintosh/.test(userAgent) && touchPoints > 1)) return "ios";
  return null;
}

/** The page's address as the app is handed it, without the one-time sign-in key of a handoff
    text, which is spent on this browser and belongs nowhere else. */
export function pageAddress(origin: string, href: string): URL {
  const url = new URL(href, origin);
  // Only when present: rewriting the query would turn other escapes into URLSearchParams' own.
  if (url.searchParams.has("key")) url.searchParams.delete("key");
  return url;
}

/** Apple's banner, only on the signed-in app's pages, never inside the app. The app routes
    `app-argument` like a universal link; Safari splits the content on commas, so those are
    escaped. */
export function appBannerFor(page: {
  signedIn: boolean;
  origin: string | undefined;
  href: string;
  userAgent: string | undefined;
}): string | null {
  if (!page.signedIn || !page.origin || appUserAgent(page.userAgent)) return null;
  const argument = pageAddress(page.origin, page.href).toString().replaceAll(",", "%2C");
  return `app-id=${APP_STORE_ID}, app-argument=${argument}`;
}

const DISMISSED = "alm.openInApp.dismissed";

export function openInAppDismissed(): boolean {
  try {
    return localStorage.getItem(DISMISSED) === "1";
  } catch {
    return false;
  }
}

export function dismissOpenInApp(): void {
  try {
    localStorage.setItem(DISMISSED, "1");
  } catch {
    // Storage refused (private mode): the bar stays away for this page only.
  }
}
